import client from "./client";

export const projectsApi = {
  list: () => client.get("/projects"),
  search: (params) => client.get("/projects/search", { params }),
  get: (id) => client.get(`/projects/${id}`),
  create: (data) => client.post("/projects", data),
  update: (id, data) => client.put(`/projects/${id}`, data),
  remove: (id) => client.delete(`/projects/${id}`),
  stats: () => client.get("/projects/stats"),
};
